import { priceKopecks } from '@krp/sale-ui'

/**
 * Сумма внесения или выплаты наличных, как её набрал кассир: рубли с запятой или точкой, не больше двух знаков после запятой,
 * больше нуля. В копейки — целым числом (деньги дробными не передаём). Текст отказа — для поля, словами.
 */
export type CashAmount = { ok: true; kopecks: number } | { ok: false; text: string }

const FORM = /^\d{1,9}(?:[.,]\d{1,2})?$/

/** Предел одной операции — 99 999 999,99 ₽: больше кассир не наберёт, а такая сумма почти наверняка опечатка. */
const MAX_KOPECKS = 9_999_999_999

export function parseCashAmount(text: string): CashAmount {
  const value = text.trim()
  if (value === '') return { ok: false, text: 'Укажите сумму' }
  if (!FORM.test(value)) return { ok: false, text: 'Сумма — число в рублях, до двух знаков после запятой' }
  const kopecks = priceKopecks(value)
  if (kopecks < 1) return { ok: false, text: 'Сумма должна быть больше нуля' }
  if (kopecks > MAX_KOPECKS) return { ok: false, text: 'Слишком большая сумма' }
  return { ok: true, kopecks }
}
